import { notification } from "antd";
import { ReactNode } from "react";

export function useNotifications() {
  const [api, contextHolder] = notification.useNotification();

  const notifySuccess = ({
    title,
    description,
  }: {
    title?: string;
    description: string | ReactNode;
  }) => {
    api.success({
      message: title ?? "Success",
      description,
    });
  };

  const notifyError = (msg?: string) => {
    api.error({
      message: "Whoops!",
      description: msg ?? "Something went wrong. Please try again.",
    });
  };

  const notifyWarn = (msg?: string) => {
    api.warning({
      message: "Alert!",
      description: msg ?? "Something is missing.",
    });
  };

  return {
    notifySuccess,
    notification: contextHolder,
    notifyError,
    notifyWarn,
  };
}
